import reducer from './reducers';

export { default as categoriesBreadcrumbsSelectors } from './selectors';
export { default as categoriesBreadcrumbsOperations } from './operations';
export { default as categoriesBreadcrumbsTypes } from './types';

export default reducer;
